import classNames from 'classnames'

import type { IIconComponentView } from './icon-component.types'

import './icon-component.styles.scss'

export const IconComponentView = ({ color, iconAlign, IconComponent, size }: IIconComponentView) => {
  if (!IconComponent) {
    return null
  }

  return (
    <div className={classNames(['icon-dashboard-wrapper', { [iconAlign]: iconAlign }])}>
      <IconComponent style={{ width: size, height: size, color }} />
    </div>
  )
}
